module.exports = __webpack_public_path__ + "img/SZDBCNBSXXX.66eac63e.png";